import createVueApp from '@phoenix/createVueApp';
import { PhxJournalSlider } from '@phx-styleguides/iwc';

document.querySelectorAll('.phoenix-page-slider').forEach((el) => {
  const app = createVueApp();
  app.component('PhxJournalSlider', PhxJournalSlider);
  app.mount(el);
});
